export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12586.48faf784.jpg";